
import articleSection from '~/pages/gameInformation/articleSection'
import GoodsAccountImg from '@/components/GoodsBox/GoodsAccountImg'
export default {
	components: {
		articleSection,
		GoodsAccountImg
	},
	data() {
		return {
			whether: 0,
			link: ''
		}
	},
	head() {
		return {
			title: `${this.articleDetailsRes.title}-盼之代售-玩家虚拟财产的守护者`,
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: this.articleDetailsRes.introduction
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: this.articleDetailsRes.seoKeywords
				}
			],
			script: [
				{
					hid: 'ldjson-schema',
					innerHTML: `{"@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonid","@id":"https://${this.BAIDU_URL}","pubDate": "${this.BAIDU_PUSH_DATE}","upDate": "${this.BAIDU_DATE}"}`,
					type: 'application/ld+json'
				}
			],
			link: [{ ref: 'canonical', href: this.CANONICAL_URL }],
			__dangerouslyDisableSanitizersByTagID: {
				'ldjson-schema': ['innerHTML']
			}
		}
	},
	async asyncData({ app, params, route }) {
		// 上一篇/下一篇接口传值
		const articleUpDown = {
			id: params.id
		}
		// 多个请求批处理   不做批量处理签名报错
		// const [articleDetailsRes, recommendedArticlesRes, pcPopularAccountsRes, articleLastRes, articleNextRes] = await Promise.all([
		//     // 获取文章详情
		//     app.$api.articleDetailsAPI(articleUpDown),
		//     // 获取推荐文章
		//     app.$api.recommendedArticlesAPI(articleUpDown),
		//     // 热门账号
		//     app.$api.pcPopularAccountsAPI(articleUpDown),
		//     // 获取上一篇
		//     app.$api.articleLastAPI(articleUpDown),
		//     // 获取下一篇
		//     app.$api.articleNextAPI(articleUpDown)
		// ])
		const articleDetailsRes = await app.$api.articleDetailsAPI(articleUpDown)
		const recommendedArticlesRes = await app.$api.recommendedArticlesAPI(articleUpDown)
		const pcPopularAccountsRes = await app.$api.pcPopularAccountsAPI(articleUpDown)
		const articleLastRes = await app.$api.articleLastAPI(articleUpDown)
		const articleNextRes = await app.$api.articleNextAPI(articleUpDown)
		console.log(articleDetailsRes, '内链管理数据')
		// 匹配内容是否存在标签 点击标签可跳转
		if (articleDetailsRes.success) {
			for (const key in articleDetailsRes.data.list) {
				const data = articleDetailsRes.data.list[key]
				let content = `<a title="${data.urlName}" href="${data.url}" target="_blank" style="color: #409eff">${data.urlName}</a>`
				let reg = new RegExp(data.urlName)
				articleDetailsRes.data.content = articleDetailsRes.data.content.replace(reg, content)
			}
		}
		return {
			BAIDU_URL: process.env.BAIDU_URL + route.path,
			CANONICAL_URL: process.env.CANONICAL_URL + route.path,
			BAIDU_DATE: app.$formattedDateTime(),
			BAIDU_PUSH_DATE: articleDetailsRes.data.publishTime.replace(' ', 'T'),
			articleDetailsRes: articleDetailsRes.success ? articleDetailsRes.data : {},
			recommendedArticlesRes: recommendedArticlesRes.success ? recommendedArticlesRes.data : {},
			pcPopularAccountsRes: pcPopularAccountsRes.success ? pcPopularAccountsRes.data : {},
			articleLastRes: articleLastRes.success ? articleLastRes.data : { title: '无' },
			articleNextRes: articleNextRes.success ? articleNextRes.data : { title: '无' }
		}
	},
	// async fetch({ store, params, query }) {},
	computed: {
		// 获取当前url
		hrefUrl() {
			if (process.browser) {
				return window.location.href
			}
		},
		orientation() {
			return function () {
				if (this.whether == 2) {
					return 'isFixed'
				} else if (this.whether == 3) {
					return 'isAbsolute'
				} else {
					return ''
				}
			}
		}
	},
	async mounted() {
		console.log(this.$route, '路由')
		// 获取最新文章列表
		await this.$store.dispatch('game/GameLatestArticlesList', { excludeId: this.$route.params.id })
		// 获取热门文章列表
		await this.$store.dispatch('game/GameHotArticlesList', { excludeId: this.$route.params.id })
		// 添加监听滚动
		if (process.browser) {
			window.addEventListener('scroll', this.handleScroll)
		}
	},
	destroyed() {
		// 销毁 EventListener
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		// 文章相似标签
		// similarTag(val) {
		//   this.$router.push({
		//     path: `/gameInformation/${val.id}/${val.name}`,
		//     query: {
		//       tagId: val.id,
		//       name: val.name,
		//     },
		//   });
		// },
		// 点击上/下一篇
		articleUpDownFu(val) {
			if (val.title == '无') return
			let routeData = this.$router.resolve({ path: `/articleDetails/${val.id}` })
			console.log(routeData, 'routeData')
			window.open(routeData.href, '_blank')
		},
		// 右侧菜单吸顶效果
		handleScroll() {
			//计算滚动条位置
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			// 右侧盒子总高度
			let boxHeight = this.$refs.rightBox.offsetHeight
			// 可视高度
			let innerHeight = window.innerHeight
			// 页面总高度
			let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
			// 滚动条距离底部的距离
			let scrollBottom = scrollHeight - innerHeight - scrollTop
			// console.log(scrollTop,'计算滚动条位置')
			// 是否吸顶
			if (scrollHeight - 439 <= boxHeight) {
				this.whether = 0
			} else if (scrollBottom < 215) {
				this.whether = 3
			} else if (scrollTop > boxHeight - innerHeight + 214) {
				this.whether = 2
			} else {
				this.whether = 0
			}
		}
	}
}
